import { GradientIcon } from '@sparemin/blockhead';
import React from 'react';
import * as S from './styles';

type EmailIconProps = {};

const EmailIcon: React.FC<EmailIconProps> = () => (
  <GradientIcon>
    <S.Email />
  </GradientIcon>
);
export default EmailIcon;
